import { isHLApp } from '@fs/utils'

export const getBaseUrl = (baseUrl = '', localProxy = false) => {
  return (isHLApp() && !localProxy) || import.meta.env.PROD ? baseUrl : ''
}
